<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Postal Area"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="postalAreas"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Postal Area</div>
      </template>

      <template #empty> No Related Job Postal Area found! </template>
      <template #loading> Loading Related Postal Area. Please wait. </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="areaPostCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.areaPostCode ? slotProps.data.areaPostCode : "" }}
        </template>
      </Column>
      <Column field="townCity" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.townCity ? slotProps.data.townCity : "" }}
        </template>
      </Column>
      <Column field="region" header="Region" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.region ? slotProps.data.region.regionName : "" }}
        </template> </Column
      >>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editPostalAreas(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="postalAreaForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Postal Area"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="postalArea.areaPostCode"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field p-col relative">
          <label for="noteHeader">Description:</label>
          <InputText
            id="noteHeader"
            v-model.trim="postalArea.townCity"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salutation">Region</label>
          <Dropdown
            :showClear="true"
            v-model="postalArea.region"
            :options="regions"
            optionLabel="regionName"
            placeholder="Select Sales Exec"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="postalArea.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="postalAreaForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Postal Area?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deletePostalArea"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { settingFormReady, idOf } from "./settingsForm";
import CustomerService from "@/service/CustomerService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  data: () => ({
    postalAreaForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    regions: [],
    postalArea: {},
    postalAreas: [],
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.postalArea = { active: true };
      this.postalAreaForm = true;
    },
    openConfirmation(data) {
      this.postalArea = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editPostalAreas(data) {
      this.postalArea = { ...data }; // SAL: edit a copy, not the list row
      this.postalAreaForm = true;
    },
    async deletePostalArea() {
      this.closeConfirmation();
      await this.customerService.deletePostalArea(this.postalArea.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Postal Area removed",
        life: 5000
      });
      this.getAllPostalAreas();
    },
    save() {
      if (!settingFormReady(this, this.postalArea, "townCity", "Description", "active")) return;
      // SAL: send the id in a copy, so a failed save leaves the form as typed
      const body = { ...this.postalArea, region: idOf(this.postalArea.region) };
      if (!this.postalArea.id) {
        this.customerService
          .postPostalArea(body)
          .then(res => {
            this.postalAreaForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Postal Area added",
              life: 5000
            });
            this.getAllPostalAreas();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving postal area",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putPostalArea(body, this.postalArea.id)
          .then(res => {
            this.postalAreaForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Postal Area updated",
              life: 5000
            });
            this.getAllPostalAreas();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating postal area",
              life: 5000
            });
          });
      }
    },
    getAllPostalAreas() {
      this.loading = true;

      this.customerService
        .getAllPostalAreas()
        .then(data => {
          this.postalAreas = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting postal area",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "postalAreas"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.customerService
      .getAllActiveRegions()
      .then(data => {
        this.regions = data;
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting regions",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeRegions"'
        });
      });

    this.getAllPostalAreas();
  }
};
</script>
